export default {
    'company':
        'logo':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif'
            ]
            'authorized_formats': 'jpeg, png, gif'
    'distribution':
        'logo':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif'
            ]
            'authorized_formats': 'jpeg, png, gif'
    'user_info':
        'photo':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif'
            ]
            'authorized_formats': 'jpeg, png, gif'
    'absence':
        'proof':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/pdf',
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif'
            ]
            'authorized_formats': 'pdf, jpeg, png, gif'
    'formation':
        'program':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/pdf',
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif'
            ]
            'authorized_formats': 'pdf, jpeg, png, gif'
    'graduate':
        'file':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/pdf',
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif'
            ]
            'authorized_formats': 'pdf, jpeg, png, gif'
    'user_job':
        'file':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/pdf',
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif'
            ]
            'authorized_formats': 'pdf, jpeg, png, gif'
    'user_voucher':
        'file':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/pdf',
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif'
            ]
            'authorized_formats': 'pdf, jpeg, png, gif'
    'pay_slip':
        'file':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/pdf',
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif'
            ],
            'authorized_formats': 'pdf, jpeg, png, gif'
    'interview_campaign':
        'user_doc':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/pdf',
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.oasis.opendocument.text',
            ]
            'authorized_formats': 'pdf, jpeg, png, gif, doc, docx, odt',
            'title': ['Doc de préparation EP collaborateur','Doc de préparation EA collaborateur']
        'manager_doc':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/pdf',
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.oasis.opendocument.text',
            ],
            'authorized_formats': 'pdf, jpeg, png, gif, doc, docx, odt',
            'title': ['Doc de préparation EP manager','Doc de préparation EA manager']
        'manager_final_doc':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/pdf',
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.oasis.opendocument.text',
            ],
            'authorized_formats': 'pdf, jpeg, png, gif, doc, docx, odt',
            'title': ['Doc final de restitution EP','Doc final de restitution EA']
    'oncall_duty':
        'file':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/vnd.ms-excel',
                'application/vnd.ms-office',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.oasis.opendocument.spreadsheet',
                'application/octet-stream',
                'text/csv',
                'text/plain',
                'text/x-csv',
                'application/csv',
                'application/x-csv',
                'text/comma-separated-values',
                'text/x-comma-separated-values',
                'text/tab-separated-values'
            ]
            'authorized_formats': 'xls, xlsx, csv, ods'
    'pro_hazard':
        'file':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.oasis.opendocument.text',
                'image/jpeg',
                'image/png',
                'application/vnd.oasis.opendocument.presentation',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            ]
            'authorized_formats': 'pdf, doc, docx, odt, ppt, pptx, odp, jpeg, png'
    'file':
        'filename':
            'max_filesize': 57671680 #55Mo
        'types':
            'other':
                'mimes': []
                'icon': 'fa fa-file-o'
                'label': 'Autre'
            'pdf':
                'mimes': [
                    'pdf'
                ]
                'icon': 'fa fa-file-pdf-o'
                'label': 'Pdf'
            'excel':
                'mimes': [
                    'excel'
                ]
                'icon': 'fa fa-file-excel-o'
                'label': 'Tableur'
            'text':
                'mimes': [
                    'msword',
                    'text'
                ]
                'icon': 'fa fa-file-text-o'
                'label': 'Texte'
            'image':
                'mimes': [
                    'image'
                ]
                'icon': 'fa fa-file-image-o'
                'label': 'Image'
            'video':
                'mimes': [
                    'video'
                ]
                'icon': 'fa fa-file-video-o'
                'label': 'Vidéo'
            'audio':
                'mimes': [
                    'audio'
                ]
                'icon': 'fa fa-file-audio-o'
                'label': 'Audio'
    'interview_file':
        'filename':
            'max_filesize': 57671680 #55Mo
        'types':
            'other':
                'icon': 'fa fa-file-o'
                'label': 'Autre'
            'pdf':
                'icon': 'fa fa-file-pdf-o'
                'label': 'Pdf'
            'excel':
                'icon': 'fa fa-file-excel-o'
                'label': 'Tableur'
            'text':
                'icon': 'fa fa-file-text-o'
                'label': 'Texte'
            'image':
                'icon': 'fa fa-file-image-o'
                'label': 'Image'
            'video':
                'icon': 'fa fa-file-video-o'
                'label': 'Vidéo'
            'audio':
                'icon': 'fa fa-file-audio-o'
                'label': 'Audio'
    'vpe':
        'file':
            'max_filesize': 57671680 #55Mo
            'mime_types': [
                'application/pdf',
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/gif'
            ]
            'authorized_formats': 'pdf, jpeg, png, gif'
    'application_types':
        'application/pdf': 'pdf'
        'application/msword': 'text'
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'text'
        'application/vnd.oasis.opendocument.text': 'text'
        'application/vnd.ms-excel': 'excel'
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel'
        'application/vnd.oasis.opendocument.spreadsheet': 'excel'
        'text/csv': 'excel'
        'text/x-csv': 'excel'
        'application/csv': 'excel'
        'application/x-csv': 'excel'
        'text/comma-separated-values': 'excel'
        'text/x-comma-separated-values': 'excel'
        'text/tab-separated-values': 'excel'
}
